export const STYLE_PRESET_SCOPE_ALL = 'all';
export const STYLE_PRESET_SCOPE_TEXT = 'text';
export const STYLE_PRESET_SCOPE_MEDIA = 'media';
export const STYLE_PRESET_SCOPES_TO_DISPLAY_NAMES = {
  [STYLE_PRESET_SCOPE_ALL]: 'All',
  [STYLE_PRESET_SCOPE_TEXT]: 'Text tiles & text sections',
  [STYLE_PRESET_SCOPE_MEDIA]: 'Media tiles (captions)'
};
